import React, { useEffect, useState } from "react";
import type { FC } from "react";
import {
  Box, Typography,
} from "@mui/material";
import { get,set } from "local-storage";
import type { EventPostbackType } from "@fas/cpa-cabinet-ui/lib/EventPostback/EventPostback.types";
import CollapseCard from "./CollapseCard";
import EventPostbackComponent from "../EventPostbackComponent";
import InputCode from "./InputCode";
import HowToCreatePostback from "./HowToCreatePostback";

type Props = Record<string, any>;

export function usePrevious<T>(value: T) {
  const ref = React.useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const PostbackUrls: FC<Props> = () => {
  const [tracking, setTracking] = useState({
    isEditable: false,
    value: "",
  });
  const [eventPostbacks, setEventPostback] = useState<EventPostbackType[]>([]);
  const prevEventPostbacks = usePrevious(eventPostbacks);
  const prevTracking = usePrevious(tracking);

  useEffect(() => {
    setEventPostback(get("postbacks") || []);
    setTracking(get("tracking") || tracking);
  }, []);

  useEffect(() => {
    if (prevEventPostbacks !== eventPostbacks) {
      set("postbacks", eventPostbacks);
    }
    if (prevTracking !== tracking) {
      set("tracking", tracking);
    }
  }, [eventPostbacks, tracking]);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" pb={2}>
        <Typography variant="h5">Postback URLs</Typography>
      </Box>

      <InputCode tracking={tracking} onChange={setTracking} />

      <Box p={2} />
      <CollapseCard title="Informational events postback">
        <Box p={3}>
          <EventPostbackComponent
            items={eventPostbacks}
            onChange={setEventPostback}
          />
        </Box>
      </CollapseCard>
      <Box p={2} />
      <HowToCreatePostback />
    </Box>
  );
};

export default PostbackUrls;
